import classNames from 'classnames';
import { quote, quoteMark } from './Quote.css';
import type { PostQuoteProps } from './Quote.types';

export const PostQuote = ({
  element,
  children,
  className,
  // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: PostQuoteProps) => {
  /* spreading props on standard DOM elements causes React warnings and hydration errors */
  return (
    <div className={classNames(className, quote)} {...props}>
      <div className={quoteMark}>❝</div>
      {children}
    </div>
  );
};
